
import Vue from 'vue'
import store from '../store'
import parts, { ColorMaterialInformation } from '../colors/components'
import { Perspective } from '@/types/Perspective'
import {ComponentPictureLoader} from '../loaders/ComponentPictureLoader'

export default Vue.extend({
  name: 'WatchComponentsContainer',
  store,
  data() {
    return {}
  },
  computed: {
    getColors(): { [key: string]: ColorMaterialInformation } {
      const colors: { [key: string]: ColorMaterialInformation } = this.$store.getters.getColors

      // get only the components for the current selected perspective and apply the colorMaterial information to the components to be shown
      const componentsToShow = this.getComponentsForPerspective(this.perspective)
      for (const component in componentsToShow) {
        if (colors[component]) {
          componentsToShow[component] = colors[component]
        }
      }
      return componentsToShow
    },
    price(): string {
      // const rawPrice = this.$store.getters.price
      // const formatter = Intl.NumberFormat('de-DE', {
      //   style: 'currency',
      //   currency: 'EUR'
      // })
      // return formatter.format(rawPrice)
      return this.$t('configurator.price').toString()
    },
    isFrontPerspective(): boolean {
      return this.perspective === Perspective.FRONT
    },
    perspective(): Perspective {
      return this.$store.getters.getPerspective
    },
    changePerspectiveText(): string {
      return this.perspective === Perspective.BACK
        ? this.$t('configurator.front').toString()
        : this.$t('configurator.back').toString()
    },
  },
  mounted() {
    // preload pictures of the other perspective
    const otherPerspective = (this.isFrontPerspective) ? Perspective.BACK : Perspective.FRONT
    const otherPerspectiveComponents = this.getComponentsForPerspective(otherPerspective)
    const colors: { [key: string]: ColorMaterialInformation } = this.$store.getters.getColors
    // setting custom colors (e.g. if someone used a shared link)
    for (const component in otherPerspectiveComponents) {
        if (colors[component]) {
          otherPerspectiveComponents[component] = colors[component]
        }
      }
    // taken from https://stackoverflow.com/questions/48090443/how-to-preload-images-using-vue-js
    for (const component in otherPerspectiveComponents) {
      const image = new Image();
      image.src = ComponentPictureLoader.load(component, colors[component].color, otherPerspective, ComponentPictureLoader.getFileSystemSuffixForMaterial(colors[component].material))
    }
  },
  methods: {
    getSrc(name: string, obj: ColorMaterialInformation) {
      return ComponentPictureLoader.load(name, obj.color, this.perspective, ComponentPictureLoader.getFileSystemSuffixForMaterial(obj.material))
    },
    changeView() {
      this.$store.commit('setOtherPerspective', Perspective.BACK)
    },
    getComponentsForPerspective(perspective: Perspective) {
      return (perspective === Perspective.FRONT) ? parts.ALL_FRONT_PARTS : parts.ALL_BACK_PARTS
    }
  },
});
